<axs-modal #modal [axsSize]="'medium'" *ngIf="modalData && isOpen">
  <dialog #dialog class="modal_container">
    <axs-modal-close>
      <ngx-axs-button
        [axsText]="commonContent.close"
        axsType="supplementary"
        axsTheme="black"
        axsIconType="close"
        (axsClick)="closeModal()"
      />
    </axs-modal-close>
    <axs-modal-content aria-label="Modal Content">
      <div class="sample-client-modal__content" [class.visible]="contentVisible">
        <div class="sample-client-modal__title text-title-1">
          <span class="sample-client-modal__title-image-container">
            <img class="sample-client-modal__title-image" src="{{modalData.imgPathCard}}" alt="" fetchpriority="high" />
          </span>
          <span class="sample-client-modal__title-text">
            {{ modalData.title }}
          </span>
        </div>
        <div class="sample-client-modal__client">
          <img class="sample-client-modal__client-image" src="{{modalData.imgPath}}" alt="" fetchpriority="high" />

          <div class="sample-client-modal__client-profile"
               [innerHTML]="modalData.clientProfile"
          ></div>
        </div>
        <div class="sample-client-modal__accordions">
          <div class="sample-client-modal__conversion-reasoning">
            <axs-accordion-controller axs-for="sample-client-modal__conversion-reasoning-panel">
              <div class="sample-client-modal__accordion-header">
                <axs-accordion-trigger>
                  <button id="sample-client-modal__conversion-reasoning-header"
                          aria-controls="sample-client-modal__conversion-reasoning-panel">
                    <div
                      class="sample-client-modal__accordion-header--label">{{ sampleClientModalContent.whyConversionMatters + modalData.name }}
                    </div>
                  </button>
                </axs-accordion-trigger>
                <axs-indicator class="accordion-indicator"></axs-indicator>
              </div>
            </axs-accordion-controller>
            <axs-accordion-panel id="sample-client-modal__conversion-reasoning-panel"
                                 role="region"
                                 aria-labelledby="sample-client-modal__conversion-reasoning-header">
              <div class="sample-client-modal__accordion-content" [innerHTML]="modalData.conversionReasoning"></div>
            </axs-accordion-panel>
          </div>
          <hr>
          <div class="sample-client-modal__calculator-explanation">
            <axs-accordion-controller axs-for="sample-client-modal__calculator-explanation-panel">
              <div class="sample-client-modal__accordion-header">
                <axs-accordion-trigger>
                  <button id="sample-client-modal__calculator-explanation-header"
                          aria-controls="sample-client-modal__calculator-explanation-panel">
                    <div
                      class="sample-client-modal__accordion-header--label">{{ sampleClientModalContent.howCalculatorHelps }}
                    </div>
                  </button>
                </axs-accordion-trigger>
                <axs-indicator class="accordion-indicator"></axs-indicator>
              </div>
            </axs-accordion-controller>
            <axs-accordion-panel id="sample-client-modal__calculator-explanation-panel"
                                 role="region"
                                 aria-labelledby="sample-client-modal__calculator-explanation-header">
              <div class="sample-client-modal__accordion-content" [innerHTML]="modalData.calculatorExplanation"></div>
            </axs-accordion-panel>
          </div>
          <hr>
        </div>
        <ngx-axs-button class="sample-client-modal__load-button"
                        [axsTheme]="ButtonTheme.vgRed"
                        [axsText]="sampleClientModalContent.loadClient"
                        (axsClick)="onLoadClient()"
        ></ngx-axs-button>
      </div>
    </axs-modal-content>
  </dialog>
</axs-modal>
